<template>
    <article class="media">
        <div class="media-left">
        <figure class="image is-64x64">
            <fa icon="code" class="fa-3x" />
        </figure>
        </div>
        <div class="media-content">
        <div class="content">
            <p class="has-text-justified">
                <strong>Comandos</strong> <small>--</small>
                
                <br>
                <span class="tags">
                    <span :class="['tag',c.color]" v-for="c in commands" :key="c.id">{{c.command}}</span>
                </span>
            </p>
            <p v-show="false">Todos los comandos de este servidor de Mu Online.</p>
        </div>
        <nav class="level is-mobile">
            <div class="level-left">
            <router-link to="/comandos" class="level-item">Ver más</router-link>
            </div>
        </nav>
        </div>
    </article>
</template>

<script>
export default {
    name: 'CommandsHomeSection',
    computed: {
        commands() {
            return this.$store.getters.GetCommands
        }
    }
}
</script>

<style>

</style>